import 'assets/css/App.css';
import 'module/charisma/assets/css/App.css';

import 'utils/setupRive'
import {useLayoutEffect} from "react";
import {Routes, Outlet, Route, Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {LandingEnum} from "_business";
import {Book, Success} from "pages";
import {Email, Paywall, PrePaywall1, PrePaywall2, Summarize, Survey, Loading} from "module/charisma/pages"
import {CookiesBanner} from "parts";
import {useLocation} from 'react-router-dom'
import {Start} from "./pages";
import {Bond} from "./parts";


if (process.env.REACT_APP_VERSION !== window.localStorage.getItem('version')) {
  window.localStorage.setItem('version', process.env.REACT_APP_VERSION)

  if (window.localStorage.getItem('survey_results')) {
    console.warn('clear')
    window.localStorage.removeItem('survey_results')
  }
}


export default function App() {
  const
    // {i18n} = useTranslation(),
    location = useLocation()

  // const
    // A77 =
    //   LandingEnum.default === window.landing && i18n.resolvedLanguage === 'en'
    //     ? getExperiment('A77')
    //     : {value: 'A'}

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
    // setTimeout(() => window.scrollTo(0, 0), 500)

    if (window.ttq) {
      window.ttq.page()
      // console.log('TikTok pageview sent for', location.pathname)
    }
  }, [location.pathname, location.hash])

  return (
    <Routes>
      <Route path="/" element={<Layout/>}>
        {
          Object.entries(LandingEnum).map(([key, value]) => {
            const
              slug = key === 'charisma' ? '' : value,
              path = `/${slug}${slug ? '/' : ''}`

            let i = -1

            return (
              <Route key={key} path={slug}>

                <Route index element={
                  <Start step={{step: ++i, page: 'start'}} toAdd={false} nextUrl={`${path}survey`}/>
                }/>

                <Route path="survey" element={
                  <Survey step={++i} nextUrl={`${path}${'loading'}`}/>
                }/>


                <Route path="loading" element={
                  <Loading step={{step: ++i, page: 'loading'}} nextUrl={`${path}email`} preload={'gift_icon.riv'}/>
                }/>

                <Route path="email" element={
                  <Email step={{step: ++i, page: 'email'}} nextUrl={`${path}prepaywall1`}/>
                }/>

                <Route path="summarize" element={
                  <Summarize step={{step: i, page: 'summarize'}} nextUrl={`${path}prepaywall1`}/>
                }/>
                <Route path="summarize/:uid" element={
                  <Summarize step={{step: i, page: 'summarize'}} nextUrl={`${path}paywall`}/>
                }/>

{/*                <Route path="emailoffers" element={
                  <EmailOffers step={{step: ++i, page: 'emailoffers'}}
                               nextUrl={`${path}prepaywall1`}
                               preload={'graphs.riv'} locale={['de'].includes(i18n.resolvedLanguage)}/>
                }/>*/}

                <Route path="prepaywall1" element={
                  <PrePaywall1 step={{step: ++i, page: 'prepaywall1'}} nextUrl={`${path}prepaywall2`}/>
                }/>
                <Route path="prepaywall2" element={
                  <PrePaywall2 step={{step: ++i, page: 'prepaywall2'}} nextUrl={`${path}paywall`}/>
                }/>

                <Route path="paywall" element={
                  <Paywall step={{step: ++i, page: 'paywall'}} nextUrl={`${path}book`}/>
                }/>
                <Route path="book" element={
                  <Book step={{step: ++i, page: 'book'}} nextUrl={`${path}success`} preload={'success.riv'}/>
                }/>
                <Route path="book/:uid" element={
                  <Book step={{step: i, page: 'book'}} nextUrl={`${path}success`} preload={'success.riv'}/>
                }/>


                <Route path="success" element={
                  <Success step={{step: ++i, page: 'success'}}/>
                }/>
                <Route path="success/:uid" element={
                  <Success step={{step: i, page: 'success'}}/>
                }/>

                <Route path="paywall/:uid" element={
                  <Paywall step={{page: 'paywall'}} nextUrl={'/book'} toAdd={false}/>
                }/>
              </Route>
            )
          })
        }

        <Route path=".well-known/apple-developer-merchantid-domain-association" element={<Apple/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Route>
    </Routes>
  )
}

function Layout() {
  // console.warn('google', JSON.stringify(window.google_tag_data?.ics?.entries.ad_storage))

  return (
    <>
      <Bond/>
      <Outlet/>
      <CookiesBanner/>
    </>
  )
}

function NotFound() {
  const {t} = useTranslation('common', {keyPrefix: 'notFound'})

  return (
    <div className={'centered'}
         style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
      <h1>{t('header')}</h1>
      <br/>
      <p>
        <Link to="/" className={'marked'}>{t('goHome')}</Link>
      </p>
    </div>
  )
}

function Apple() {
  fetch(require('assets/apple'), {
    method: 'GET',
    // headers: {
    //   'Content-Type': 'application/pdf',
    // },
  })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      )
      const link = document.createElement('a')
      link.href = url;
      link.setAttribute(
        'download',
        `apple-developer-merchantid-domain-association`,
      )

      // Append to html link element page
      document.body.appendChild(link)

      // Start download
      link.click()

      // Clean up and remove the link
      link.parentNode.removeChild(link)
    })
}